import { Link, useMatch, useResolvedPath } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Container from 'react-bootstrap/Container'
import Brand from './Brand'
import HeaderDecoration from './HeaderDecoration';
import { useTranslation } from 'react-i18next';

export const Header = () => {
    const { t } = useTranslation();
    const navigation = t('navigation');

    return (
        <div className='position-relative'>
            <HeaderDecoration />
            <Navbar className='py-3 py-lg-4' variant='dark' expand="lg">
                <Container>
                    <Link to="/" className='navbar-brand'><Brand /></Link>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mx-auto">
                            {
                                navigation.map((item, index) => {
                                    return (
                                        <div key={index} className='mt-3 mt-lg-0'>
                                            <CustomLink to={item.href}>{item.text}</CustomLink>
                                        </div>
                                    )
                                })
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}

const CustomLink = ({ children, to }) => {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });
    return (
        <div>
            {match ? <ActiveNavLink to={to}>{children}</ActiveNavLink> : <NavLink to={to}>{children}</NavLink>}
        </div>
    );
}

const NavLink = ({ children, to }) => {
    return (
        <div className='px-lg-3'>
            <Link to={to} className='nav-link'>
                <span className='d-block text-white fs-15 pt-lg-1'>{children}</span>
            </Link>
        </div>
    )
}

const ActiveNavLink = ({ children, to }) => {
    return (
        <div className='d-flex flex-column align-items-lg-center mx-lg-3'>
            <Link to={to} className='pt-0 nav-link'>
                <span className='d-block text-white fs-28 fw-bold'>{children}</span>
            </Link>
            <i className="fa-solid fa-circle text-white d-none d-lg-block"></i>
        </div>
    )
}

export default Header